import { render, staticRenderFns } from "./DashboardForm.vue?vue&type=template&id=32264d3c&scoped=true&"
import script from "./DashboardForm.vue?vue&type=script&lang=ts&"
export * from "./DashboardForm.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardForm.vue?vue&type=style&index=0&id=32264d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32264d3c",
  null
  
)

export default component.exports